module.exports = __webpack_public_path__ + "img/H5.7415a1d6.png";